import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import AppForm from '../../components/AppForm';
import {Button, Tooltip, OverlayTrigger, Popover, SplitButton, MenuItem} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, DateTimePicker, FileUpload, CKEditor, Number, ImageUpload, Select} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import Help from '../../components/Help';
import MultiCheckbox from '../../components/Form/MultiCheckbox';
import RadioList from '../../components/Form/RadioList';
import Checkbox from '../../components/Form/IconCheckbox';
import ChangeBar from '../../components/ChangeBar';
import {ModalWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import RequiredSymbol from '../../components/RequiredSymbol';
import NavBar from '../../components/NavBar';
import TableForm from "../../components/TableForm";
import {TabGroup, Tab} from 'reactis-tabs';
import immutable from 'immutable';
import ButtonToolbar from '../../components/ButtonToolbar';


@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)}
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'emaillayout.fetch',
			save: 'emaillayout.save',
			remove: 'emaillayout.delete'
		};

		this.changeEvent = 'emaillayout.change';
		this.savePushState = '/emaillayout';

		this.messages = {
			remove: 'Opravdu si přejete layout odstranit?',
			notfound: 'Layout nenalezen!'
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				rules: {
					presence: {message: 'Zadejte název!'}
				}
			},
			text: {
				class: CKEditor,
				label: 'Text',
				toolbar: null,
				height: 550
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}


	render() {

		const isNew = !this.props.id;
		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = 1 || this.user.isAllowed('post', isNew ? 'insert' : 'update');
		const canDelete = 1 || this.user.isAllowed('post', 'delete');

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={() => this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit jako nový',
				icon: 'fa fa-copy',
				loading: loading,
				visible: !isNew && canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save(false, true)
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				visible: canEdit,
				disabled: !canEdit,
				bsStyle: 'default',
				onClick: () => this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				visible: !isNew && canDelete,
				bsStyle: 'danger',
				color: '#A00',
				onClick: () => this.remove()
			}
		];

		return (
			<AppForm id={this.props.tabid} form={this.form} ref="form">
				<NavBar buttons={toolbar} onClose={this.props.closeTab} title="E-mailový layout"/>
				{!this.props.popup && <Toolbar title="E-mailový layout">
					<ButtonToolbar buttons={toolbar}/>
				</Toolbar>}
				<ChangeBar visible={this.state.showChangedBar} items={this.state.extChangedItems}
						   onAcceptChanges={() => this.acceptChanges()}
						   onClose={() => this.setState({showChangedBar: false})}/>

				<div className="row">
					<div className="col-md-9">
						<TableForm>
							<FormRow name="title" labelWidth={135}/>
							<FormRow name="text"/>
						</TableForm>
					</div>
				</div>
			</AppForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Emaillayout/Form.js